function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoCodesColoredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ff9f22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m450 240v30h30v30h30v-30-25-5z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 240h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270 240h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m180 240h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 240h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 245v25 30h30v-30h30v-30h-60z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480 420h-30v30h60v-5-25-30h-30z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 390h-30v30 25 5h60v-30h-30z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 420h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270 420h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 420h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 420h60v30h-60z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 330h30v30h-30z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480 330h30v30h-30z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.033 304.394-21.213 21.213-21.214-21.213-21.212 21.212 21.213 21.214-21.213 21.213 21.212 21.213 21.214-21.213 21.213 21.213 21.213-21.213-21.213-21.213 21.213-21.214z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.89 346.82 21.22 21.21-21.22 21.22-21.21-21.22v-42.42l21.21-21.22 21.22 21.22z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.68 325.61v42.42l-21.21 21.22-21.22-21.22 21.22-21.21-21.22-21.21 21.22-21.22z",
    fill: "#ff9900",
    "data-original": "#ffda44",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.606 325.606-21.212-21.212-21.214 21.213-21.213-21.213-21.213 21.212 21.213 21.214-21.213 21.213 21.213 21.213 21.213-21.213 21.214 21.213 21.212-21.213-21.213-21.213z",
    fill: "#ff9900",
    "data-original": "#ff9f22",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.379 210h-3.758c-27.912 0-50.621-22.708-50.621-50.621v-48.758c0-27.913 22.709-50.621 50.621-50.621h3.758c27.912 0 50.621 22.708 50.621 50.621v9.379h-30v-9.379c0-11.371-9.251-20.621-20.621-20.621h-3.758c-11.37 0-20.621 9.25-20.621 20.621v48.758c0 11.371 9.251 20.621 20.621 20.621h3.758c11.37 0 20.621-9.25 20.621-20.621v-9.379h30v9.379c0 27.913-22.709 50.621-50.621 50.621z",
    fill: "#ff9900",
    "data-original": "#ff415b",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.379 210h-3.758c-27.912 0-50.621-22.708-50.621-50.621v-48.758c0-27.913 22.709-50.621 50.621-50.621h3.758c27.912 0 50.621 22.708 50.621 50.621v48.758c0 27.913-22.709 50.621-50.621 50.621zm-3.758-120c-11.37 0-20.621 9.25-20.621 20.621v48.758c0 11.371 9.251 20.621 20.621 20.621h3.758c11.37 0 20.621-9.25 20.621-20.621v-48.758c0-11.371-9.251-20.621-20.621-20.621z",
    fill: "#ff9900",
    "data-original": "#ff415b",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.379 210h-54.379v-150h54.379c27.912 0 50.621 22.708 50.621 50.621v48.758c0 27.913-22.709 50.621-50.621 50.621zm-24.379-30h24.379c11.37 0 20.621-9.25 20.621-20.621v-48.758c0-11.371-9.251-20.621-20.621-20.621h-24.379z",
    fill: "#ff9900",
    "data-original": "#b40042",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 90v-30h-105v150h105v-30h-75v-30h55v-30h-55v-30z",
    fill: "#ff9900",
    "data-original": "#b40042",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoCodesColoredIcon);
export default __webpack_public_path__ + "static/media/promo-codes-colored-icon.04fba1a6a4a3a3119ab30cf978af93a8.svg";
export { ForwardRef as ReactComponent };